import { USERS_TYPE } from "../../data/Constants";

export const sidebarItems = {
    [USERS_TYPE.USER]: [
        {
            name: "Dashboard",
            path: "/dashboard",
        },
        {
            name: "Certificate",
            path: "/certifications",
        },
        {
            name: "CPD Activities",
            path: "/cpd-activities",
        },
        {
            name: "Profile",
            path: "/profile",
        },
        {
            name: "Billing",
            path: "/billing",
        },
    ],
    [USERS_TYPE.ATP_USER]: [
        {
            name: "Dashboard",
            path: "/atp/dashboard",
        },
        {
            name: "Profile",
            path: "/atp/profile",
        },
        {
            name: "CPD Activities",
            path: "/atp/cpdactivities",
        },
        {
            name: "Billing",
            path: "/atp/billing",
        },
        {
            name: "Resources",
            path: "/atp/resources",
        },
    ],
};
